'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortDropDown = require('./components/SortDropDown.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SortDropDown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/sort-dropdown/lib/index.js
// module id = 372
// module chunks = 1